import { createContext, ReactNode, useContext, useMemo } from 'react';

type IPurchaseConsigneeContext = {
  /**
   * Consignee account the purchase is being created for (consignor master view only).
   * Null means the consignor's own account, ie. today's behavior.
   */
  consigneeSellerAccountId: string | null;
};

export const PurchaseConsigneeContext =
  createContext<IPurchaseConsigneeContext>({
    consigneeSellerAccountId: null,
  });

/**
 * The consignee the purchase vendor/vendor account/user/payment method data should be scoped to.
 * Outside a provider this is always null, so the data is the current account's.
 */
export const usePurchaseConsigneeSellerAccountId = () =>
  useContext(PurchaseConsigneeContext).consigneeSellerAccountId;

export const PurchaseConsigneeContextProvider = ({
  consigneeSellerAccountId,
  children,
}: {
  consigneeSellerAccountId: string | null | undefined;
  children: ReactNode;
}) => {
  const value = useMemo(
    () => ({ consigneeSellerAccountId: consigneeSellerAccountId ?? null }),
    [consigneeSellerAccountId]
  );

  return (
    <PurchaseConsigneeContext.Provider value={value}>
      {children}
    </PurchaseConsigneeContext.Provider>
  );
};
